module.exports = "/shared/fonts/Futura/web/FtraMd-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./src/ui/fonts/Futura/web/FtraMd-webfont.woff
// module id = 34
// module chunks = 13